import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";

var _dec, _dec2, _dec3, _class, _class2, _descriptor;

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { inject, injectable, postConstruct } from 'inversify';
import 'reflect-metadata';
import { TYPES } from '../../../types';
var PostProcessor = (_dec = injectable(), _dec2 = inject(TYPES.IRendererService), _dec3 = postConstruct(), _dec(_class = (_class2 = function () {
  function PostProcessor() {
    _classCallCheck(this, PostProcessor);

    _initializerDefineProperty(this, "rendererService", _descriptor, this);

    _defineProperty(this, "passes", []);

    _defineProperty(this, "readFBO", void 0);

    _defineProperty(this, "writeFBO", void 0);
  }

  _createClass(PostProcessor, [{
    key: "getReadFBO",
    value: function getReadFBO() {
      return this.readFBO;
    }
  }, {
    key: "getWriteFBO",
    value: function getWriteFBO() {
      return this.writeFBO;
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(layer) {
        var i, pass;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                i = 0;

              case 1:
                if (!(i < this.passes.length)) {
                  _context.next = 10;
                  break;
                }

                pass = this.passes[i];
                pass.setRenderToScreen(this.isLastEnabledPass(i));
                _context.next = 6;
                return pass.render(layer);

              case 6:
                if (i !== this.passes.length - 1) {
                  this.swap();
                }

              case 7:
                i++;
                _context.next = 1;
                break;

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function render(_x) {
        return _render.apply(this, arguments);
      }

      return render;
    }()
  }, {
    key: "resize",
    value: function resize(width, height) {
      this.readFBO.resize({
        width: width,
        height: height
      });
      this.writeFBO.resize({
        width: width,
        height: height
      });
    }
  }, {
    key: "add",
    value: function add(pass, layer, config) {
      pass.init(layer, config);
      this.passes.push(pass);
    }
  }, {
    key: "insert",
    value: function insert(pass, index, layer, config) {
      pass.init(layer, config);
      this.passes.splice(index, 0, pass);
    }
  }, {
    key: "getPostProcessingPassByName",
    value: function getPostProcessingPassByName(name) {
      return this.passes.find(function (p) {
        return p.getName() === name;
      });
    }
  }, {
    key: "init",
    value: function init() {}
  }, {
    key: "isLastEnabledPass",
    value: function isLastEnabledPass(index) {
      for (var i = index + 1; i < this.passes.length; i++) {
        if (this.passes[i].isEnabled()) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "swap",
    value: function swap() {
      var tmp = this.readFBO;
      this.readFBO = this.writeFBO;
      this.writeFBO = tmp;
    }
  }]);

  return PostProcessor;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "rendererService", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "init", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "init"), _class2.prototype)), _class2)) || _class);
export { PostProcessor as default };
//# sourceMappingURL=PostProcessor.js.map